<template>
    <sidebar-menu :menu="menus"
                  :width="width"
                  :showOneChild="showOneChild"
                  @item-click="onItemClick"
                  hide-toggle
                  v-if="menus.length > 0">
        <div slot="header">
            <h1 class="logo">
                <router-link to="/">
<!--                    <img src="@/assets/images/common/logo2.png" alt="logo"/>-->
                </router-link>
            </h1>
        </div>
    </sidebar-menu>
</template>

<script>
    import {SidebarMenu} from 'vue-sidebar-menu'
    import {getToken} from '@/utils/auth';
    import jwt_decode from 'jwt-decode';

    import menuApi from '@/api/MenuApi';

    export default {
        name: "SideNav",
        comments: {
            SidebarMenu
        },
        props: {
            width: {
                type: String,
                default: '220px'
            },
            showOneChild: {
                type: Boolean,
                default: true
            },
        },
        data() {
            return {
              menus: []
                // menus: [
                //     {
                //         href: '/',
                //         title: '대시보드',
                //         icon: 'mdi mdi-view-dashboard'
                //     },
                //     {
                //       title: '회원관리',
                //       icon: 'fa fa-users',
                //       href: '/user/STATE_NORMAL',
                //       child: [
                //         {
                //           href: '/user/STATE_NORMAL',
                //           title: '일반회원',
                //           icon: 'mdi mdi-account mdi-18px',
                //           alias:['/user']
                //         },
                //         {
                //           href: '/user/STATE_REQUEST',
                //           title: '대기회원',
                //           icon: 'mdi mdi-account-outline mdi-18px'
                //         },
                //         {
                //           href: '/user/STATE_DORMANT',
                //           title: '휴면회원',
                //           icon: 'mdi mdi-sleep mdi-18px'
                //         },
                //         {
                //           href: '/user/STATE_WITHDRAW',
                //           title: '탈퇴회원',
                //           icon: 'mdi mdi-account-minus mdi-18px'
                //         },
                //         {
                //           href: '/user/STATE_WITHDRAW_REQUEST',
                //           title: '탈퇴대기',
                //           icon: 'mdi mdi-account-minus-outline mdi-18px'
                //         },
                //         {
                //           href: '/user/STATE_BLOCKED',
                //           title: '차단회원',
                //           icon: 'mdi mdi-account-off mdi-18px'
                //         },
                //       ]
                //     },
                //     {
                //       href: '/group/meeting',
                //       title: '모임 관리',
                //       icon: 'fab fa-meetup fa-lg',
                //       child: [
                //         {
                //           href: '/group/meeting',
                //           title: '모임 관리',
                //           icon: 'fab fa-meetup fa-lg',
                //           alias: ['/group/meeting*']
                //         },
                //         {
                //           href: '/group',
                //           title: '분류 관리',
                //           icon: 'mdi mdi-file-tree mdi-18px'
                //         }
                //       ]
                //     },
                //     {
                //       href: '/schedule',
                //       title: '일정 관리',
                //       icon: 'mdi mdi-calendar',
                //     },
                //     {
                //       title: '게시판 관리',
                //       icon: 'mdi mdi-clipboard-text-outline',
                //       child: [
                //         {
                //           href: '/board/221/articles',
                //           title: '공지사항',
                //           icon: 'mdi mdi-clipboard-text-outline',
                //           alias: ['/board/221/article*']
                //         },
                //         {
                //           href: '/board',
                //           title: '게시판 설정',
                //           icon: 'mdi mdi-clipboard-text-outline',
                //           alias: ['/board/form/:id', '/board/:id/articles*', '/board/:id/article*']
                //         }
                //       ]
                //     },
                //     {
                //       href: '/page',
                //       title: '페이지 관리',
                //       icon: 'mdi mdi-book-open-page-variant-outline',
                //       alias:['/page*']
                //     },
                //     {
                //     title: '알림 관리',
                //     icon: 'mdi mdi-bell',
                //     child: [
                //       {
                //         href: '/banner/TYPE_HOME_VISUAL',
                //         title: '배너관리',
                //         icon: 'mdi mdi-alpha-b-box mdi-18px',
                //         alias:['/banner*'],
                //         child: [
                //           {
                //             href: '/banner/TYPE_HOME_VISUAL',
                //             title: 'Home Visual',
                //             icon: 'mdi mdi-alpha-b-box mdi-18px'
                //           },
                //           {
                //             href: '/banner/TYPE_HOME_MAIN',
                //             title: 'Main Banner',
                //             icon: 'mdi mdi-alpha-b-box mdi-18px'
                //           },
                //           {
                //             href: '/banner/TYPE_LOGIN',
                //             title: 'Login Banner',
                //             icon: 'mdi mdi-alpha-b-box mdi-18px'
                //           },
                //         ]
                //       },
                //       {
                //         href: '/popup',
                //         title: '팝업관리',
                //         icon: 'mdi mdi-alpha-p-box mdi-18px',
                //         alias:['/popup*']
                //       },
                //       {
                //         href: '/sms',
                //         title: 'SMS 발송',
                //         icon: 'mdi mdi-send mdi-18px',
                //       },
                //       {
                //         href: '/mail',
                //         title: '메일관리',
                //         icon: 'mdi mdi-mail mdi-18px',
                //       }
                //     ]
                //   },
                //     {
                //       href: '/statistic',
                //       title: '통계 관리',
                //       icon: 'mdi mdi-chart-bar',
                //     },
                //     {
                //       title: '설정 관리',
                //       icon: 'mdi mdi-cog',
                //       child: [
                //         {
                //           href: '/role',
                //           title: '역할관리',
                //           icon: 'mdi mdi-access-point-check mdi-18px'
                //         },
                //         {
                //           href: '/menu',
                //           title: '메뉴 관리',
                //           icon: 'mdi mdi-menu mdi-18px',
                //         },
                //         {
                //           href: '/site',
                //           title: '사이트 관리',
                //           icon: 'mdi mdi-home-edit mdi-18px',
                //         }
                //       ]
                //     },
                // ],
              , allowedMenus: []
            }
        },
        computed: {
        },
        methods: {
          /* eslint no-unused-vars: 0 */
          onItemClick(evt, item, node) {
            // console.log(item);
            this.$store.commit('setMenu', item.menu);
          },
          menuParse(m) {

            if(!m.activated) {
              return null;
            }

            if(m.menuType === 'TYPE_BOARD') {
              m.url = `/board/${m.boardId}/articles`;
            }

            m.alias = m.url ? m.url+"*" : null;
            return {
              menu: m,
              id : m.menuId,
              protected : m.protected,
              title : m.menuName,
              icon : m.menuIcon,
              href : m.url??null,
              // alias: m.alias,
              child : m?.childMenus?.length??0 > 0 ? m?.childMenus?.map(this.menuParse).filter(c => c !== null).filter(c => !c.protected || this.allowedMenus.includes(c.id)) : null
            }
          }
        },
        created() {

          // const token =  getToken();
          // this.allowedMenus = jwt_decode(token).adminMenus;
          this.allowedMenus = this.$store.getters['user/menus'];

          menuApi.list('ADMIN').then(resultSet => {
            // console.log(resultSet);
            this.menus = resultSet.map(this.menuParse).filter(m => m !== null).filter(m => !m.protected || this.allowedMenus.includes(m.id));

            // this.$store.commit('setUserMenus', this.menus);
            // localStorage.setItem('userMenus', JSON.stringify(this.menus)); // login 에서 처리
          });

        }
    }
</script>

<style lang="scss" scoped>
    .logo {
        display: flex;
        //width: 62px;
        //height: 32px;
        margin: 20px auto;
        width: 119px;
        height: 39px;
        background: url(data:image/png;base64,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) center center no-repeat;
        font-size: 0;
        filter: invert(50%);
    }
    .v-sidebar-menu .vsm--title {
      font-size: 50px;
    }
</style>
<style lang="scss">

.v-sidebar-menu .vsm--link_level-1 {
  .vsm--title {
    font-size: 18px;
  }
  .vsm--icon {
    font-size: 18px;
  }
}
.v-sidebar-menu .vsm--link_level-2 {
  .vsm--title {
    font-size: 16px;
  }
  .vsm--icon {
    font-size: 16px;
    padding-left: 10px;
  }
}
.v-sidebar-menu .vsm--link_level-3 {
  .vsm--title {
    font-size: 14px;
  }
  .vsm--icon {
    font-size: 14px;
    padding-left: 15px;
  }
}
</style>
